module.exports = function generateJsonApiIncludes(config) {
	let includeApi = "";
	if (
		config.options &&
		config.options.list &&
		config.options.list.relationships &&
		Array.isArray(config.options.list.relationships) &&
		config.options.list.relationships.length > 0
	) {
		includeApi += "include=";
		includeApi += config.options.list.relationships.join(",");
	}
	return includeApi;
};
